import { useContext } from 'react'

import { CommonUseContext } from 'contexts'

export default function useCommon() {
  return useContext(CommonUseContext)
}
